import { render } from "./DataDesc.vue?vue&type=template&id=338dbf51"
import script from "./DataDesc.vue?vue&type=script&lang=js"
export * from "./DataDesc.vue?vue&type=script&lang=js"

import "./DataDesc.vue?vue&type=style&index=0&id=338dbf51&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__